import { Trophy, Zap } from 'lucide-react';

const PRIZES = [
  { place: '1st place', sats: '1,000,000 sats', detail: 'Plus mentorship & demo day intros' },
  { place: '2nd place', sats: '600,000 sats', detail: 'Plus hardware wallets for the team' },
  { place: '3rd place', sats: '400,000 sats', detail: 'Plus swag and sats to keep building' },
];

export function Prizes() {
  return (
    <section className="relative isolate overflow-hidden bg-accent py-20 text-accent-foreground sm:py-24">
      {/* decorative glows */}
      <div className="absolute -left-24 top-0 -z-10 size-96 rounded-full bg-primary/20 blur-3xl" aria-hidden />
      <div className="absolute -right-24 bottom-0 -z-10 size-96 rounded-full bg-primary/15 blur-3xl" aria-hidden />

      <div className="container space-y-12">
        <div className="mx-auto max-w-2xl space-y-4 text-center">
          <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.3em] text-primary">
            <Trophy className="size-4" aria-hidden />
            Prize Pool
          </p>
          <h2 className="font-display text-4xl font-semibold tracking-tight text-balance text-white sm:text-5xl">
            2,100,000 sats up for grabs
          </h2>
          <p className="text-lg leading-relaxed text-accent-foreground/70">
            A nod to 21 million — paid instantly over Lightning, straight to your own wallet.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-3">
          {PRIZES.map((prize) => (
            <div
              key={prize.place}
              className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-primary/40"
            >
              <p className="text-sm font-bold uppercase tracking-[0.25em] text-white/60">
                {prize.place}
              </p>
              <p className="mt-3 font-display text-3xl font-semibold text-primary">
                {prize.sats}
              </p>
              <p className="mt-2 text-sm text-accent-foreground/60">{prize.detail}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-accent-foreground/60">
          <Zap className="mr-1 inline size-4 text-primary" aria-hidden />
          Bonus: 100,000 sats for the best Nostr hack — chosen by community zaps.
        </p>
      </div>
    </section>
  );
}
